import { gql } from '@apollo/client'

export const CUSTOMER_CEL_VERIFICATIONS_STATUS = gql`
  query customerCelVerificationStatus{
     customerCelVerificationStatus {
        inSession
        cel{
            countryCode
            phoneCode
            phoneNumber
        }
        status
        lastWhatsappIntent  
        nextWhatsappIntent
        whatsappIntentCount
        lastSMSIntent
        nextSMSIntent
        SMSIntentCount
        uid
     }
  }
`
